// 对账单记录列表
export const statements = {
  searchPlaceholder: '交易订单号/退款订单号',
  tableHead: [
    {
      prop: 'contrastDate',
      label: '对账日期',
    },
    {
      prop: 'batchNumber',
      label: '对账批次编号',
      width: 160,
    },
    {
      prop: 'channel',
      label: '对账渠道',
    },
    {
      prop: 'results',
      label: '对账结果',
    },
    {
      prop: 'contrastAmount',
      label: '对账金额',
    },
    {
      prop: 'contrastCount',
      label: '对账笔数',
    },
    {
      prop: 'errorAmount',
      label: '差错金额',
    },
    {
      prop: 'errorCount',
      label: '差错数',
    },
    {
      prop: '',
      label: '操作',
    },
  ],
  query_form_list: [
    {
      label: '对账结果',
      prop: 'result1',
      options: [
        {
          key: '全部状态',
          value: '',
        },
        {
          key: '异常',
          value: 'FAIL',
        },
        {
          key: '正常',
          value: 'SUCCESS',
        },
        {
          key: '对账中',
          value: 'UNCONTRAST',
        },
      ],
    },
    {
      label: '对账渠道',
      prop: 'result2',
      options: [
        {
          key: '全部状态',
          value: '',
        },
        {
          key: '微信',
          value: 'WECHAT',
        },
        {
          key: '支付宝',
          value: 'ALIPAY',
        },
        {
          key: '银联',
          value: 'UNIONPAY',
        },
      ],
    },
  ],
};
// 差错记录列表
export const error = {
  searchPlaceholder: '交易订单号/差错编号',
  tableHead: [
    {
      prop: 'contrastDate',
      label: '对账日期',
    },
    {
      prop: 'batchNumber',
      label: '对账批次编号',
      width: 160,
      className: 'batch',
    },
    {
      prop: 'errorNumber',
      label: '差错编号',
      width: 160,
    },
    {
      prop: 'channel',
      label: '对账渠道',
    },
    {
      prop: 'errorType',
      label: '差错类型',
    },
    {
      prop: 'processingState',
      label: '处理状态',
    },
    {
      prop: '',
      label: '操作',
      width: 170,
    },
  ],
  query_form_list: [
    {
      label: '差错状态',
      prop: 'result1',
      options: [
        {
          key: '全部状态',
          value: '',
        },
        {
          key: '待处理',
          value: '0',
        },
        {
          key: '已处理',
          value: '1',
        },
      ],
    },
    {
      label: '差错类型',
      prop: 'result2',
      options: [
        {
          key: '全部类型',
          value: '',
        },
        {
          key: '状态不符',
          value: '2',
        },
        {
          key: '平台漏单',
          value: '1',
        },
      ],
    },
  ],
};
// 详情所需数据
export const detail = {
  detailTable: new Map([
    [
      'reconciliation/list/detail',
      [
        {
          title: '对账总览',
          tableHeader: [
            {
              prop: 'batchNumber',
              label: '对账批次编号',
            },
            {
              prop: 'contrastDate',
              label: '对账日期',
            },
            {
              prop: 'channel',
              label: '对账渠道',
            },
            {
              prop: 'errorCount',
              label: '总差错',
            },
            {
              prop: 'untreatedErrorCount',
              label: '未处理差错',
            },
            {
              prop: 'results',
              label: '对账状态',
            },
          ],
        },
        {
          title: '渠道交易详情',
          tableHeader: [
            {
              prop: 'channelTradeAmount',
              label: '渠道交易总金额(元)',
            },
            {
              prop: 'channelTradeCount',
              label: '渠道交易总单数',
            },
            {
              prop: 'channelPayAmount',
              label: '渠道支付总金额(元)',
            },
            {
              prop: 'channelPayCount',
              label: '渠道支付总单数',
            },
            {
              prop: 'channelRefundAmount',
              label: '渠道退款总金额(元)',
            },
            {
              prop: 'channelRefundCount',
              label: '渠道退款总单数',
            },
            {
              prop: 'channelPoundage',
              label: '渠道服务费(元)',
            },
          ],
        },
        {
          title: '平台交易详情',
          tableHeader: [
            {
              prop: 'platformTradeAmount',
              label: '平台交易总金额(元)',
            },
            {
              prop: 'platformTradeCount',
              label: '平台交易总单数',
            },
            {
              prop: 'platformPayAmount',
              label: '平台支付总金额(元)',
            },
            {
              prop: 'platformPayCount',
              label: '平台支付总单数',
            },
            {
              prop: 'platformRefundAmount',
              label: '平台退款总金额(元)',
            },
            {
              prop: 'platformRefundCount',
              label: '平台退款总单数',
            },
          ],
        },
      ],
    ],
    [
      'reconciliation/error/detail',
      [
        {
          title: '差错总览',
          tableHeader: [
            {
              prop: 'batchNumber',
              label: '对账批次编号',
            },
            {
              prop: 'errorNumber',
              label: '差错编号',
            },
            {
              prop: 'channel',
              label: '对账渠道',
            },
            {
              prop: 'errorType',
              label: '差错类型',
            },
            {
              prop: 'processingState',
              label: '处理状态',
            },
          ],
        },
        {
          title: '平台订单信息',
          tableHeader: [
            {
              prop: 'platformMchOrderNo',
              label: '平台商户订单号',
            },
            {
              prop: 'platformTradeNo',
              label: '平台交易订单号',
            },
            {
              prop: 'platformTradeTime',
              label: '平台交易时间',
            },
            {
              prop: 'platformPayTime',
              label: '平台支付时间',
            },
            {
              prop: 'platformTradeState',
              label: '平台交易状态',
            },
            {
              prop: 'platformOrderAmount',
              label: '平台订单金额(元)',
            },
            {
              prop: 'platformShouldAmount',
              label: '平台应结金额(元)',
            },
            {
              prop: 'platformPayAmount',
              label: '平台支付金额(元)',
            },
          ],
        },
        {
          title: '渠道订单信息',
          tableHeader: [
            {
              prop: 'payChannel',
              label: '支付渠道',
            },
            {
              prop: 'channelOrderNo',
              label: '渠道订单号',
            },
            {
              prop: 'channelTradeNo',
              label: '渠道支付流水号',
            },
            {
              prop: 'channelTradeTime',
              label: '渠道交易时间',
            },
            {
              prop: 'channelPayTime',
              label: '渠道支付时间',
            },
            {
              prop: 'channelTradeState',
              label: '渠道交易状态',
            },
            {
              prop: 'channelOrderAmount',
              label: '渠道订单金额(元)',
            },
            {
              prop: 'channelShouldAmount',
              label: '渠道应结金额(元)',
            },
            {
              prop: 'channelPayAmount',
              label: '渠道支付金额(元)',
            },
          ],
        },
      ],
    ],
  ]),
  // 差错处理
  handleError: new Map([
    ['reconciliation/error/detail', []],
    [
      'reconciliation/list/detail',
      [
        {
          label: '对账差错信息',
          children: [
            {
              prop: 'errorNumber',
              label: '差错编号',
              width: 170,
            },
            {
              prop: 'errorType',
              label: '差错类型',
            },
            {
              prop: 'processingState',
              label: '处理状态',
            },
          ],
        },
        {
          label: '渠道账号信息',
          children: [
            {
              prop: 'channelOrderAmount',
              label: '交易金额',
            },
            {
              prop: 'channelTradeState',
              label: '渠道账单类型',
            },
            {
              prop: 'platformTradeTime',
              label: '平台交易时间',
              width: 170,
            },
          ],
        },
        {
          label: '操作',
          width: 170,
        },
      ],
    ],
  ]),

  title: new Map([
    ['reconciliation/list/detail', '对账单详情'],
    ['reconciliation/error/detail', '平台漏单详情'],
  ]),
};
